import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../domain/registrator';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  endpoint: string = environment.api_url;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient) { }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.endpoint}/users`, { headers: this.headers });
  }

  createUser(user: Object): Observable<any> {
    return this.http.post(`${this.endpoint}/users`, user, { headers: this.headers });
  }

  updateUser(id: number, user: Object): Observable<any> {
    return this.http.put(`${this.endpoint}/users/${id}`, user, { headers: this.headers });
  }

  toggleUser(id: number, enabled: boolean): Observable<any> {
    return this.http.put(`${this.endpoint}/users/${id}/enabled`, { enabled: enabled }, { headers: this.headers });
  }

  deleteUser(id: number): Observable<any> {
    return this.http.delete(`${this.endpoint}/users/${id}`, { headers: this.headers });
  }

  sendPasswordReset(id: number): Observable<any> {
    return this.http.post(`${this.endpoint}/users/${id}/resetpassword`, {}, { headers: this.headers });
  }
}
